import { render, staticRenderFns } from "./ToolbarSelector.vue?vue&type=template&id=03db66a4&"
import script from "./ToolbarSelector.vue?vue&type=script&lang=js&"
export * from "./ToolbarSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports